<template>
    <div class="c-app">
        <div class="container">
            <div class="d-flex title-option mt-2">
                <div class="btn-home mt-2 ms-auto">
                    <button type="button" class="btn btn-outline-main" @click="returnHome()">
                        <i class="fas fa-home-lg-alt"></i> Inicio
                    </button>
                </div>
            </div>
            
            <div class="h-100 d-flex align-items-center">
                <div class="w-100" v-if="subpage == 'buttons'">
                    <div class="d-md-flex flex-wrap justify-content-center mt-2">
                        <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 col-xs-12 mb-4 px-1">
                            <div class="card card-home-cirujano shadow" @click="mtdShowBook('reporte_caja')">
                                <h4>REPORTES DE CAJA</h4>
                                <div class="icon-book">
                                    <img class="img-fluid-bed-sop rounded-start" src="../../../assets/gerencia/reporte_caja.png" alt="" />
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 col-xs-12 mb-4 px-1">
                            <div class="card card-home-cirujano shadow" @click="mtdShowBook('cierre_caja')">
                                <h4>CIERRES DE CAJA</h4>
                                <div class="icon-book">
                                    <img class="img-fluid-bed-sop rounded-start" src="../../../assets/caja/caja-registradora.png" alt="" />
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 col-xs-12 mb-4 px-1">
                            <div class="card card-home-cirujano shadow" @click="mtdShowBook('inreso_egreso')">
                                <h4>INGRESO/EGRESO</h4>
                                <div class="icon-book">
                                    <img class="img-fluid-bed rounded-start" src="../../../assets/gerencia/reporte_ing.png" alt="" />
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 col-xs-12 mb-4 px-1">
                            <div class="card card-home-cirujano shadow" @click="mtdShowBook('cxc')">
                                <h4>CXC</h4>
                                <div class="icon-book">
                                    <img class="img-fluid-bed rounded-start" src="../../../assets/caja/cuenta-por-cobrar.png" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

    
<script>
import {
    mapActions
} from 'vuex';

export default {
    name: 'c-admision-footerCaja',
    data() {
        return {
            subpage: "buttons",
        }
    },
    methods: {
        ...mapActions(['get', 'post']),

        mtdShowBook(subpage) {
            this.$emit('mtdChangePage', subpage);
        },
        returnHome() {
            this.$emit('mtdChangePage', 'home');
        },

    }

}
</script>
